import { RetailMatchSelectionMethod } from "../../Enums/RetailMatchSelectionMethod";

export interface IGetBrandsSampleSetDataByClosestRequest {
  ids: string[];
  siteLatitude: number;
  siteLongitude: number;
  sampleCountByBrand: number;
  selectionMethod: RetailMatchSelectionMethod;
  includeAllBuds: boolean;
}
